<template>
  <div class="bg-beige-lighter pt-4 pl-4">
    <p @click="$store.dispatch('drawer/close')" class="btn-close">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"></path>
      </svg>
    </p>
    <ul class="place-list flex overflow-x-scroll mt-4">
      <template v-if="places && places.length > 0">
        <li v-for="place in places" v-bind:key="place.id">
          <place :recommend="place" />
        </li>
      </template>
      <template v-else>
        <li v-for="n in dummies" v-bind:key="n">
          <place-loading />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Place from './Place'
import PlaceLoading from './PlaceLoading'
import _ from 'lodash'

export default {
  components: {
    Place,
    PlaceLoading
  },
  data () {
    return {
      places: []
    }
  },
  mounted () {
    this.updatePlaces();
  },
  methods: {
    updatePlaces: function () {
      // Vuexストアから場所のリストを取得
      this.places = this.$store.getters['places/getPlaces'].slice();
      // placeを中心地点からの距離でソート
      this.places.sort((a, b) => {
        return (this.getDistance(this.center.lat, this.center.lng, a.location.latitude, a.location.longitude) < this.getDistance(this.center.lat, this.center.lng, b.location.latitude, b.location.longitude) ? -1 : 1);
      });
      // 最初の10個の要素だけを取得
      this.places = this.places.slice(0, 10);
    },
    getDistance: function (lat1, lng1, lat2, lng2) {
      lat1 *= Math.PI / 180;
      lng1 *= Math.PI / 180;
      lat2 *= Math.PI / 180;
      lng2 *= Math.PI / 180;
      const d = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))
      return d;
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter'
    }),
    dummies: function () {
      return _.range(10)
    }
  },
  watch: {
    center: function () {
      this.updatePlaces();
    }
  }
}
</script>
